import { currencyReplacer as mentalCurrencyReplacer } from '@mentalgrowth/web_utils';

export const currencyReplacer = mentalCurrencyReplacer;
